import { Box, Checkbox, Typography } from '@mui/material';
import { MouseEvent } from 'react';
import { ReactComponent as VerticalDots } from '../../../../../../../assets/vertical-dots.svg';
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks';
import { toggleFilter } from '../../../../../../../store/slices/calendarSlice';
import zeplinColor from '../../../../../../../theme/Color';
import { LightTooltip } from '../../../../../../shared/CustomTooltip/CustomTooltip';
import styles from './AccountRowItem.module.css';

export const AccountRowItem = ({
  account: { title, value, type, color },
  onSettingsClick,
}: {
  account: {
    title: string;
    icon: string;
    type: string;
    value: string;
    color: string;
  };
  onSettingsClick: (
    e: MouseEvent<HTMLImageElement>,
    accountValue: {
      title: string;
      color: string;
      type: string;
      value: string;
    },
  ) => void;
}) => {
  const { colors, filters } = useAppSelector((state) => state.calendar);
  const dispatch = useAppDispatch();

  const isChecked = !filters.includes(title);
  const displayColor = colors[value] || colors[type] || zeplinColor.BasicBlack;
  console.log({ type });
  const handleToggle = () => {
    dispatch(
      toggleFilter({
        tool: title,
        isVisible: !isChecked,
      }),
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mb: '8px',
          gap: '8px',
          width: '100%',
          alignItems: 'flex-start',
        }}
      >
        <Checkbox
          onChange={handleToggle}
          checked={isChecked}
          sx={{
            color: color || zeplinColor.BasicBlack,
            borderRadius: '4px',
            padding: '0',
            '&.Mui-checked': {
              color: color || zeplinColor.BasicBlack,
            },
          }}
        />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <LightTooltip
            title={
              <Typography variant='body3' color={zeplinColor.Neutral1}>
                {value}
              </Typography>
            }
            placement='auto'
            style={{
              backgroundColor: zeplinColor.BasicBlack,
              borderRadius: '8px',
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: '14px', xl: '16px' },
                color: zeplinColor.BasicBlack,
                maxWidth: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {value}
            </Typography>
          </LightTooltip>
          <Typography variant='label1' color={zeplinColor.Neutral8}>
            {title}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          padding: '5px',
          display: 'flex',
          borderRadius: '50%',
          '&:hover': { backgroundColor: zeplinColor.Neutral4 },
        }}
      >
        {type !== 'huddle' && (
          <VerticalDots
            className={styles['vertical-icon']}
            onClick={(e: any) => {
              e.stopPropagation();
              onSettingsClick(e, { title, value, type, color });
            }}
            style={{ cursor: 'pointer' }}
          />
        )}
      </Box>
    </Box>
  );
};
